import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _messageEvents;

import { BeaconEvent } from './events';
import { BeaconMessageType } from '.';
export var messageEvents = (_messageEvents = {}, _defineProperty(_messageEvents, BeaconMessageType.PermissionRequest, {
  sent: BeaconEvent.PERMISSION_REQUEST_SENT,
  success: BeaconEvent.PERMISSION_REQUEST_SUCCESS,
  error: BeaconEvent.PERMISSION_REQUEST_ERROR
}), _defineProperty(_messageEvents, BeaconMessageType.PermissionResponse, {
  sent: BeaconEvent.UNKNOWN,
  success: BeaconEvent.UNKNOWN,
  error: BeaconEvent.UNKNOWN
}), _defineProperty(_messageEvents, BeaconMessageType.OperationRequest, {
  sent: BeaconEvent.OPERATION_REQUEST_SENT,
  success: BeaconEvent.OPERATION_REQUEST_SUCCESS,
  error: BeaconEvent.OPERATION_REQUEST_ERROR
}), _defineProperty(_messageEvents, BeaconMessageType.OperationResponse, {
  sent: BeaconEvent.UNKNOWN,
  success: BeaconEvent.UNKNOWN,
  error: BeaconEvent.UNKNOWN
}), _defineProperty(_messageEvents, BeaconMessageType.SignPayloadRequest, {
  sent: BeaconEvent.SIGN_REQUEST_SENT,
  success: BeaconEvent.SIGN_REQUEST_SUCCESS,
  error: BeaconEvent.SIGN_REQUEST_ERROR
}), _defineProperty(_messageEvents, BeaconMessageType.SignPayloadResponse, {
  sent: BeaconEvent.UNKNOWN,
  success: BeaconEvent.UNKNOWN,
  error: BeaconEvent.UNKNOWN
}), _defineProperty(_messageEvents, BeaconMessageType.BroadcastRequest, {
  sent: BeaconEvent.BROADCAST_REQUEST_SENT,
  success: BeaconEvent.BROADCAST_REQUEST_SUCCESS,
  error: BeaconEvent.BROADCAST_REQUEST_ERROR
}), _defineProperty(_messageEvents, BeaconMessageType.BroadcastResponse, {
  sent: BeaconEvent.UNKNOWN,
  success: BeaconEvent.UNKNOWN,
  error: BeaconEvent.UNKNOWN
}), _defineProperty(_messageEvents, BeaconMessageType.Acknowledge, {
  sent: BeaconEvent.UNKNOWN,
  success: BeaconEvent.UNKNOWN,
  error: BeaconEvent.UNKNOWN
}), _defineProperty(_messageEvents, BeaconMessageType.Disconnect, {
  sent: BeaconEvent.UNKNOWN,
  success: BeaconEvent.UNKNOWN,
  error: BeaconEvent.UNKNOWN
}), _defineProperty(_messageEvents, BeaconMessageType.Error, {
  sent: BeaconEvent.UNKNOWN,
  success: BeaconEvent.UNKNOWN,
  error: BeaconEvent.UNKNOWN
}), _messageEvents);